import { keepPreviousData } from '@tanstack/react-query'

import { useDealAugustPromoDealsRetrieve } from '@/api/gen'

import { PromoDealCard } from './promo-deal-card'

export const PromoDealsList = () => {
  const { data } = useDealAugustPromoDealsRetrieve({
    query: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      placeholderData: keepPreviousData,
    },
  })

  return (
    <section className="flex flex-wrap justify-center gap-4">
      {data !== undefined &&
        data.deals.length > 0 &&
        data.deals.map((deal) => (
          <PromoDealCard
            key={deal.deal_id}
            {...deal}
          />
        ))}
    </section>
  )
}
